import { AllExcursions } from '@/app/pages/all-excursions/all-excursions';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const allExcursionsSearchSchema = z.object({
  cityId: z.string().optional(),
});

export const Route = createFileRoute('/all-excursions/')({
  component: AllExcursions,
  validateSearch: allExcursionsSearchSchema,
});
